(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-footer"]) return;
  try {
    document.querySelectorAll('.nk-contact details').forEach(function(details){if(details.querySelector('.nk-success,.errors'))details.open=true;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-main"] && !Shopify.designMode) return;
  try {
    
if (!window.noonkindV2Events) {
 window.noonkindV2Events=true;
 document.addEventListener('change',function(e){
  if(!e.target.matches('.nk-product-form select[name="id"]'))return;
  const form=e.target.closest('form'); const section=form.closest('[data-nk-section]');
  const option=e.target.selectedOptions[0]; const add=form.querySelector('[data-nk-add]');
  if(!option||!add)return;
  section.querySelectorAll('[data-nk-price]').forEach(function(price){price.textContent=option.dataset.price;});
  add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
 });
}

if (!window.noonkindPhotoEvents) {
 window.noonkindPhotoEvents=true;
 const showPhoto=function(dialog,links,index){
  const photo=links[(index+links.length)%links.length];
  dialog.nkPhotoIndex=(index+links.length)%links.length;
  const image=document.createElement('img');image.src=photo.href;image.alt=photo.dataset.nkAlt;image.decoding='async';
  dialog.querySelector('[data-nk-gallery-stage]').replaceChildren(image);
  dialog.querySelector('[data-nk-gallery-caption]').textContent=photo.dataset.nkCaption;
  dialog.querySelector('[data-nk-gallery-count]').textContent=(dialog.nkPhotoIndex+1)+' / '+links.length;
 };
 document.addEventListener('click',function(event){
  const photo=event.target.closest('[data-nk-photo]');
  if(photo){
   const section=photo.closest('[data-nk-section]');const dialog=section.querySelector('[data-nk-gallery-dialog]');
   if(!dialog||typeof dialog.showModal!=='function')return;
   event.preventDefault();dialog.nkPhotoLinks=Array.from(section.querySelectorAll('[data-nk-photo]'));dialog.nkPhotoOpener=photo;
   showPhoto(dialog,dialog.nkPhotoLinks,dialog.nkPhotoLinks.indexOf(photo));dialog.showModal();
   if(!dialog.nkPhotoReady){
    dialog.nkPhotoReady=true;
    dialog.addEventListener('close',function(){if(dialog.nkPhotoOpener?.isConnected)dialog.nkPhotoOpener.focus();});
    dialog.addEventListener('keydown',function(keyEvent){if(keyEvent.key==='ArrowRight'||keyEvent.key==='ArrowLeft'){keyEvent.preventDefault();showPhoto(dialog,dialog.nkPhotoLinks,dialog.nkPhotoIndex+(keyEvent.key==='ArrowRight'?1:-1));}});
   }
   return;
  }
  const control=event.target.closest('[data-nk-gallery-prev],[data-nk-gallery-next]');
  if(control){const dialog=control.closest('[data-nk-gallery-dialog]');showPhoto(dialog,dialog.nkPhotoLinks,dialog.nkPhotoIndex+(control.hasAttribute('data-nk-gallery-next')?1:-1));}
  if(event.target.matches('[data-nk-gallery-dialog]'))event.target.close();
 });
}


  } catch(e) { console.error(e); }
})();
})();
